import { useGetBranding } from '@myrentalmate/api-client';
import { useParams } from 'react-router';

import { SignInPage } from './SignInPage';
import { okData } from '../../lib/apiData';

/** /o/:slug — shows the org's branding on the sign-in page. Grants nothing. */
export function BrandedSignIn() {
  const { slug = '' } = useParams();
  const { data } = useGetBranding(slug, { query: { retry: false } });
  return <SignInPage orgName={okData(data)?.name} />;
}
